module.exports = __webpack_public_path__ + "assets/img_freshdirect.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_freshdirect.jpg
 ** module id = 10
 ** module chunks = 1
 **/